import { observer } from 'mobx-react'
import VerticalLayout from 'components/Layouts/VerticalLayout'
import { useActivePlayProfile } from 'hooks/use-active-play-profile'

// Thin wrapper used at the route level for /play-dashboard + /play-profile.
// Reads the active play profile and forwards its role as activeProfileType to
// VerticalLayout, so LeftSidebar items can be guarded by profile type without
// the layout component depending on a page-scoped hook directly.
const PlayLayoutRoute = () => {
  const { active } = useActivePlayProfile()
  return <VerticalLayout usePlayTopbar activeProfileType={active?.role} />
}

export default observer(PlayLayoutRoute)
